export const en = {
    'feed-required': 'Please save a feed',
    'general-rate-max-price': 'Maximum bid must be no more than {maxValue} {currency}',
    'general-rate-min-price': 'Maximum bid must be no less than {minValue} {currency}',
    'name-empty': 'Group name not entered'
};
